/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { ViewChild, ElementRef, Renderer2, Component, Input, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { userTypes } from '../../login/login.config';

@Component({
    selector: 'icebutton',
    templateUrl: './icebutton.component.html',
    styleUrls: ['./icebutton.component.scss']
})
export class IcebuttonComponent implements OnInit {
    @Input() id: string = "";
  @Input() buttonSettings: IcecontrolSettings = null;
  @Input() disableButton: boolean = false;
    btnText: string = "";
    @Output() ButtonClick: EventEmitter<any> = new EventEmitter<any>();

    // Data Members
    iconClass: string = "";

    constructor(private elem: ElementRef,
      private renderer: Renderer2, public router: Router) { }

    ngOnInit() {
        if (Iceutility.isdefined(this.buttonSettings) && Iceutility.isdefined(this.buttonSettings.properties)) {
            this.btnText = this.buttonSettings.properties["text"];
            this.id = this.buttonSettings.id;
            // TODO: replace this with Renderer
            let btnElem = this.elem.nativeElement.children[0];

            if (Iceutility.isdefined(this.buttonSettings.properties["glyphClass"])) {
                this.iconClass = "fas " + this.buttonSettings.properties["glyphClass"];
            }

            if (Iceutility.isdefined(this.buttonSettings.properties["class"]) &&
                this.buttonSettings.properties["class"].constructor.name === "Array") {
                let classObj = this.buttonSettings.properties["class"];

                for (let icls = 0; icls < classObj.length; icls++) {
                    var obj = classObj[icls];
                    if (obj === null || obj === undefined) {
                        continue;
                    }

                    this.renderer.addClass(btnElem, obj);
                }
            }
        }
  }

    isDisabled(): boolean {
      if (this.buttonSettings == null || this.buttonSettings.permissions == null) return false;
      return this.buttonSettings.permissions.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
    }

    OnButtonClick(event) {
      event.buttonSettings = this.buttonSettings;
      this.ButtonClick.emit(event);
    }
}


@Component({
  selector: 'icepanelbutton',
  templateUrl: './icebutton.component.html',
  styleUrls: ['./icebutton.component.scss']
})
export class IcepanelbuttonComponent implements OnInit {
  @Input() id: string = "";
  @Input() buttonSettings: IcecontrolSettings = null;
  btnText: string = "";
  @Output() ButtonClick: EventEmitter<any> = new EventEmitter<any>();

  iconClass: string = "";
  permission: IcecontrolPermission = null;

  constructor(private elem: ElementRef,
    private renderer: Renderer2, public router: Router,
    @Inject(IcepanelComponent) private parent: IcepanelComponent) { }

  ngOnInit() {
    if (Iceutility.isdefined(this.buttonSettings) && Iceutility.isdefined(this.buttonSettings.properties)) {
      this.btnText = this.buttonSettings.properties["text"];
      this.id = this.buttonSettings.id;
      // TODO: replace this with Renderer
      let btnElem = this.elem.nativeElement.children[0];
      let spanElem = btnElem.children[0];

      if (Iceutility.isdefined(this.buttonSettings.properties["glyphClass"])) {
        this.iconClass = "fas " + this.buttonSettings.properties["glyphClass"];
      }

      if (Iceutility.isdefined(this.buttonSettings.properties["class"]) &&
        this.buttonSettings.properties["class"].constructor.name === "Array") {
        let classObj = this.buttonSettings.properties["class"];

        for (let icls = 0; icls < classObj.length; icls++) {
          var obj = classObj[icls];
          if (obj === null || obj === undefined) {
            continue;
          }

          this.renderer.addClass(btnElem, obj);
        }
      }
    }
  }

  OnButtonClick(event) {
    event.buttonSettings = this.buttonSettings;

    if (this.parent && this.parent.controlClick)
      this.parent.onControlClick(event);
    else
      this.ButtonClick.emit(event);

    // emit to control observers
    if (this.buttonSettings.getClickControlEvent() != null) {
      this.buttonSettings.getClickControlEvent().emit(event);
    }
  }

  isDisabled(): boolean {
    if (this.buttonSettings == null || this.buttonSettings.permissions == null) return false;

    if (this.buttonSettings.getDisabled()) return true;

    return this.buttonSettings.permissions.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
  }
}
